import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 2px;
`;
